import React from 'react';
import type { ComponentPropsWithoutRef, CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@actual-app/components/button';
import {
  SvgArrowButtonLeft1,
  SvgArrowButtonRight1,
} from '@actual-app/components/icons/v2';
import { theme } from '@actual-app/components/theme';
import { Tooltip } from '@actual-app/components/tooltip';
import { View } from '@actual-app/components/view';

type ToggleButtonProps = {
  isCollapsed?: boolean;
  onToggle?: ComponentPropsWithoutRef<typeof Button>['onPress'];
  // Backward compatibility
  isFloating?: boolean;
  onFloat?: ComponentPropsWithoutRef<typeof Button>['onPress'];
  style?: CSSProperties;
};

export function ToggleButton({
  style,
  isCollapsed,
  onToggle,
  isFloating,
  onFloat,
}: ToggleButtonProps) {
  const { t } = useTranslation();
  const collapsed = isCollapsed ?? isFloating ?? false;
  const handleToggle = onToggle ?? onFloat;
  const tooltipText = collapsed ? t('Expand sidebar') : t('Collapse sidebar');

  return (
    <View style={{ ...style, flexShrink: 0 }}>
      <Tooltip content={tooltipText} placement={collapsed ? 'right' : 'bottom'}>
        <Button
          variant="bare"
          aria-label={tooltipText}
          onPress={handleToggle}
          style={{
            color: theme.sidebarItemText,
            padding: 6,
            borderRadius: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {collapsed ? (
            <SvgArrowButtonRight1 style={{ width: 14, height: 14 }} />
          ) : (
            <SvgArrowButtonLeft1 style={{ width: 14, height: 14 }} />
          )}
        </Button>
      </Tooltip>
    </View>
  );
}
